export const UNAUTHENTICATED_ROUTES = ['/sign-in', '/sign-up', '/onboarding']
export const UNAUTHENTICATED_ROUTE_PREFIXES = ['/invite/']

export interface PathInfo {
  path: string
  isUnauthenticatedRoute: boolean
  isAuthCallback: boolean
  isProtectedRoute: boolean
}

export function getPathInfo(): PathInfo {
  const path = typeof window !== 'undefined' ? window.location.pathname : ''
  const isUnauthenticatedRoute =
    UNAUTHENTICATED_ROUTES.includes(path) || UNAUTHENTICATED_ROUTE_PREFIXES.some((prefix) => path.startsWith(prefix))
  const isAuthCallback = path === '/auth/callback' || path.startsWith('/auth/callback')
  const isProtectedRoute = !isUnauthenticatedRoute && !isAuthCallback

  return {
    path,
    isUnauthenticatedRoute,
    isAuthCallback,
    isProtectedRoute,
  }
}
